import React from "react"
import { Row, Col, Card, CardBody, Button, Modal, Label } from "reactstrap"
import MetaTags from 'react-meta-tags'
import { Link } from "react-router-dom"
import Flatpickr from "react-flatpickr";

// datatable related plugins
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider, PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import ClipLoader from "react-spinners/ClipLoader";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import "../datatables.scss"
import { useState } from "react";
import { useEffect } from "react";
import { deletePricesProviders, deleteRegion, getPricesProviders, getRegions } from "helpers/backend_helper";
import { deleteProduct } from 'helpers/backend_helper';
import { Alert } from "reactstrap";
import ModalForm from "./modal-form";
import usePage from "hooks/usePage";
import BreadcrumbNav from "components/Common/BreadcrumbNav";
import DatePicker from "react-flatpickr";
import classNames from "classnames";
import { Spanish } from "components/Nibble/Common/Inputs/NibbleBaseInput";
import dayjs from "dayjs";

const initEnterprise = {
  id: '',
  price_date: new Date(),
  enterprise: '',
  product: '',
  price: 0
}

const breadcrumbItems = [
  { id: '1', title: 'Pedidos', link: '', active: false },
  { id: '2', title: 'Concentrado de precios', link: '', active: true }
];

const CatalogPriceProviderList = (props) => {
  const { page, setPage, sizePerPage } = usePage();

  const [region, setRegion] = useState(initEnterprise);
  const [enterprise, setEnterprise] = useState(initEnterprise);
  const [enterprises, setEnterprises] = useState([])
  const [products, setProducts] = useState([])
  const [error, setError] = useState(null)
  const [row, setRow] = useState(null)
  const [modal_standard, setmodal_standard] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [dateSelected, setDateSelected] = useState(null)

  async function handleDelete(evt, row) {
    setLoading(true);
    try {
      const response = await deletePricesProviders(row.id);
      setData(data.filter(item => item.id !== row.id))
    } catch (error) {
      setError(error.toString())
    }
    setLoading(false);
    tog_standard()
  }

  function buttonActions(cell, row, rIdx) {
    return (
      <span>
        <button onClick={() => {
          setEnterprise({
            ...row,
            product: { label: row.product, value: row.product },
            enterprise: { label: row.enterprise, value: row.enterprise }
          })
          setIsOpenModal(true)
        }} className="btn btn-sm btn-danger" title="Edit">
          <i className="fas fa-edit"></i>
        </button>
        <Button
          type="button"
          className="btn btn-sm btn-danger ms-1"
          onClick={(evt) => { tog_standard(); setRow(row); }}
          title="Borrar">
          <i className="fas fa-times"></i>
        </Button>
      </span>
    )
  }

  buttonActions.displayName = 'buttonEdit'

  const columns = [
    {
      dataField: 'enterprise',
      text: 'Proveedor',
      sort: true
    },
    {
      dataField: 'product',
      text: 'Producto',
      sort: true
    },
    {
      dataField: 'price',
      text: 'Precio',
      sort: true
    },
    {
      dataField: 'price_date',
      text: 'Fecha',
      sort: true,
      formatter: (cell) => {
        const date = dayjs(cell);
        return date.format('DD-MM-YYYY');
      }
    },
    {
      dataField: 'id',
      text: 'Acciones',
      formatter: buttonActions
    }
  ];

  // Table Data
  let [color, setColor] = useState("#f46a6a");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);

  async function getData() {
    setLoading(true);
    try {
      const resp = await getPricesProviders({
        price_date: dateSelected ? dateSelected.toISOString().split('T')[0] : null
      });
      setData(resp.providers);
      setTotalSize(resp.providers.length);
      setProducts(resp.products);
      setEnterprises(resp.enterprises);
      setError(null)
    } catch (error) {
      setError(error.toString())
    }
    setLoading(false);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (dateSelected)
      getData();
  }, [dateSelected]);

  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];

  const pageOptions = {
    sizePerPage,
    totalSize,
    custom: true,
    page,
    onPageChange: setPage,
    hideSizePerPage: true
  }

  const { SearchBar } = Search;

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  function tog_standard() {
    setmodal_standard(!modal_standard);
    removeBodyCss();
  }

  const afterSearch = (results) => {
    setTotalSize(results.length);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Concentrado de precios</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbNav title="Concentrado de precios" items={breadcrumbItems} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {error ? <Alert color="danger">{error}</Alert> : null}

                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField='id'
                    columns={columns}
                    data={data}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField='id'
                        columns={columns}
                        data={data}
                        search={{ afterSearch }}
                      >
                        {toolkitProps => (
                          <React.Fragment>

                            <Row className="mb-2">
                              <Col md="3">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar
                                      {...toolkitProps.searchProps}
                                      placeholder='Buscar'
                                      onSearch={(data) => {
                                        setPage(1);
                                        toolkitProps.searchProps.onSearch(data);
                                      }}
                                    />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col md="2">
                                <Flatpickr
                                  wrapperClassName={"d-inline-block w-75"}
                                  className={classNames({
                                    "form-control": true,
                                  })}
                                  options={{
                                    dateFormat: "d/m/Y",
                                    locale: Spanish,
                                  }}
                                  name="fecha"
                                  value={dateSelected}
                                  onChange={(e) => setDateSelected(e[0])}
                                  placeholder="Filtrar por fecha"
                                />
                              </Col>
                              <Col md="7" className="text-end">
                                {/* <Link to="/catalogs/regions/form-create" className="btn btn-danger btn-sm">
                                  <i className="fas fa-plus"></i> Crear Región
                              </Link> */}
                                <button onClick={() => {
                                  setEnterprise(initEnterprise)
                                  setIsOpenModal(true)
                                }} className="btn btn-danger btn-sm">
                                  <i className="fas fa-plus"></i> Crear Proveedor
                                </button>
                              </Col>
                            </Row>

                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle table-nowrap"
                                    }
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    noDataIndication={loading ? <ClipLoader color={color} loading={loading} size={30} /> : 'Sin datos'}
                                  />

                                </div>
                              </Col>
                            </Row>

                            <Row className="align-items-md-center mt-30">
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                </div>
                                <div className="text-md-right ms-auto">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </React.Fragment>
                        )
                        }
                      </ToolkitProvider>
                    )
                    }</PaginationProvider>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ModalForm
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
          enterprise={enterprise}
          getData={getData}
          enterprises={enterprises}
          products={products}
        />
      </div>
      <Modal
        isOpen={modal_standard}
        toggle={() => {
          tog_standard();
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Borrar Proveedor
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_standard(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>
            ¿Está seguro de borrar el proveedor?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_standard();
            }}
            className="btn btn-secondary "
            data-dismiss="modal"
          >
            <i className="fas fa-times"></i> Cerrar
          </button>
          <button
            onClick={(evt) => handleDelete(evt, row)}
            type="button"
            className="btn btn-danger"
          >
            <i className="fas fa-check"></i> Borrar
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default CatalogPriceProviderList
